export default __webpack_public_path__ + "static/media/new_order_sound.974b5d2e.mp3";